import OutsideClickHandler from "react-outside-click-handler";
import { useState } from "react";
import { MdClose, MdCheck } from "react-icons/md";

import { useEffect } from "react";

const UserSelectModal = ({ shown, onCancel, onSave, userArray, selectedUserIdArray }) => {
  const [checkList, setCheckList] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  useEffect(() => {
    setAllChecked(false);
  }, [shown]);

  useEffect(() => {
    let temp = [];
    if (selectedUserIdArray.length === 0) {
      for (let i = 0; i < userArray.length; i++) {
        temp.push(false);
      }
    } else {
      for (let i = 0; i < userArray.length; i++) {
        if (selectedUserIdArray.includes(String(userArray[i].id))) {
          temp.push(true);
        } else {
          temp.push(false);
        }
      }
    }
    setCheckList(temp);
  }, [userArray, selectedUserIdArray]);

  const toggleAt = (index) => {
    setCheckList((prev) => {
      const temp = [...prev];
      temp[index] = !temp[index];
      return temp;
    });
  };

  const save = () => {
    let temp = [];
    for (let i = 0; i < userArray.length; i++) {
      if (checkList[i]) {
        temp.push(userArray[i]);
      }
    }
    onSave(temp);
  };

  const allCheckChanged = (checked) => {
    setAllChecked(checked);
    setCheckList(new Array(checkList.length).fill(checked));
  };

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        <OutsideClickHandler
          onOutsideClick={() => {
            onCancel();
          }}
        >
          <div className="w-[440px] max-h-[90vh] flex flex-col bg-white rounded-[12px] shadow-[0px_10px_10px_-5px_rgba(0,0,0,0.04),0px_20px_25px_-5px_rgba(0,0,0,0.10)]">
            {/* Header */}
            <div className="flex items-start justify-between gap-3 px-6 py-4 border-b-[1px] border-borderColor">
              <div className="flex flex-col gap-1">
                <p className="font-OpenSansSemiBold text-[20px] leading-[28px] capitalize text-titleColor">
                  Select Users
                </p>
                <p className="font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] text-subTitleColor">
                  Choose who should receive this.
                </p>
              </div>
              <button
                type="button"
                onClick={onCancel}
                className="w-8 h-8 rounded-full flex items-center justify-center text-[#868DA6] hover:text-titleColor"
              >
                <MdClose size={18} />
              </button>
            </div>

            {/* Select all */}
            <div
              onClick={() => allCheckChanged(!allChecked)}
              className="flex items-center gap-3 px-6 py-3 border-b-[1px] border-borderColor cursor-pointer"
            >
              <CheckTile checked={allChecked} onToggle={() => allCheckChanged(!allChecked)} />
              <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-titleColor">
                Select All
              </span>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-auto px-6 py-2">
              {userArray.map((user, index) => {
                // The picker endpoint carries role names, so labels read
                // "Name (Role)"; email is the fallback for a user with no role.
                const subtitle = user.roles?.[0]?.name ?? user.email;
                return (
                  <div
                    key={index}
                    onClick={() => toggleAt(index)}
                    className="w-full flex items-center gap-3 py-2 cursor-pointer"
                  >
                    <CheckTile checked={!!checkList[index]} onToggle={() => toggleAt(index)} />
                    <p className="font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] text-titleColor">
                      {user.name} {subtitle && <span className="text-subTitleColor">({subtitle})</span>}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-4 px-6 py-4 border-t-[1px] border-borderColor">
              <button
                type="button"
                onClick={onCancel}
                className="h-10 px-1 rounded-[6px] font-OpenSansSemiBold text-[16px] leading-[24px] capitalize text-subTitleColor"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={save}
                className="h-10 px-4 rounded-[8px] bg-blueColor flex items-center justify-center font-OpenSansSemiBold text-[16px] leading-[24px] capitalize text-white cursor-pointer"
              >
                Save
              </button>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
};

const CheckTile = ({ checked, onToggle }) => (
  <button
    type="button"
    onClick={(event) => {
      event.stopPropagation();
      onToggle();
    }}
    className={`w-[18px] h-[18px] rounded-[4px] border flex items-center justify-center shrink-0 transition-colors ${
      checked ? "border-[#0065FD] bg-[#0065FD]" : "border-[#C9CEE2] bg-white"
    }`}
  >
    {checked && <MdCheck size={14} className="text-white" />}
  </button>
);

export default UserSelectModal;
